__turbopack_context__.v({
  "h2": "StyleConstants-module__KfP3Eq__h2",
  "p": "StyleConstants-module__KfP3Eq__p",
  "sectionPadding": "StyleConstants-module__KfP3Eq__sectionPadding",
});
